import {
	BookText,
	Car,
	LogIn,
	LogOut,
	Menu,
	Settings,
	Upload,
	User,
	Users,
	X,
	Album,
	Notebook,
	Book,
	ChevronDown,
	ChevronUp,
	BookOpenCheck,
	Handshake, BookMarked, Activity, FileText,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { deleteCookie, getCookie } from 'cookies-next';
import { Fragment } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { decode } from '../lib/encryption';

export default function Navbar() {
	const pathname = useLocation();
	const history = useHistory();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [isMounted, setIsMounted] = useState(false);
	const [trainingManagementOpen, setTrainingManagementOpen] = useState(false);
	const [user, setUser] = useState<any>({});
	useEffect(() => {
		setIsMounted(true);
		console.log(pathname)
		if (pathname.pathname.search('auth') < 0){
			setUser(JSON.parse(decode(getCookie('user').toString())) || {});
		}else {
			setUser({})
		}
	},[pathname]);

	const menuItems = [
		{
			name: 'Khóa học',
			href: '/courses',
			icon: <BookText className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/courses'),
		},
		{
			name: 'Giáo viên',
			href: '/teachers',
			icon: <Users className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/teachers'),
		},
		{
			name: 'Xe',
			href: '/vehicles',
			icon: <Car className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/vehicles'),
		},
		{
			name: 'Hạng đào tạo',
			href: '/license',
			icon: <Album className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/license'),
		},
		{
			name: 'Đơn vị liên kết',
			href: '/partner',
			icon: <Handshake className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/partner'),
		},
		{
			name: 'Tải lên',
			href: '/upload',
			icon: <Upload className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/upload'),
		},
		{
			name: 'Cài đặt',
			href: '/settings',
			icon: <Settings className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/settings'),
		},
		{
			name: 'AuditLog',
			href: '/audit-log',
			icon: <Activity className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/audit-log'),
		},
	];

	const trainingManagementItems = [
		{
			name: 'Kế hoạch đào tạo',
			href: '/training-plans',
			icon: <Notebook className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/training-plans'),
		},
		{
			name: 'Môn học',
			href: '/subjects',
			icon: <Book className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/subjects'),
		},
		{
			name: 'Giáo án',
			href: '/lesson-plans',
			icon: <BookOpenCheck className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/lesson-plans'),
		},
		{
			name: 'Quyết định',
			href: '/decisions',
			icon: <FileText className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/decisions'),
		},
		{
			name: 'Cuối kì',
			href: '/end-semester',
			icon: <BookMarked className='w-5 h-5' />,
			current: pathname.pathname.startsWith('/end-semester'),
		},
	];

	// Sắp xếp lại menuItems theo thứ tự mới
	const reorderedMenuItems = [
		menuItems[0], // Khóa học
		menuItems[1], // Giáo viên
		menuItems[2], // Xe
		menuItems[3], // Hạng đào tạo
		// Quản lý đào tạo sẽ được thêm ở giữa
		menuItems[4], // Đơn vị liên kết
		menuItems[5], // Tải lên
		menuItems[6], // Cài đặt
		menuItems[7], // Log
	];

	if (!isMounted) return null;

	const handleLogout = () => {
		deleteCookie('auth-token');
		deleteCookie('user');
		setUser({});
		history.push('/auth');
	};
	return (
		<>
			{/* Mobile menu button */}
			{!mobileMenuOpen ? (
				<button
					className='lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white shadow-md'
					onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
					<Menu className='w-6 h-6' />
				</button>
			) : (
				''
			)}

			{/* Desktop sidebar */}
			<nav className={user.Name ? 'hidden lg:flex fixed left-0 top-0 h-full w-64 bg-white shadow-md z-40 flex-col' : 'hidden'}>
				<div className='p-4 border-b border-gray-200'>
					<h1 className='text-xl font-bold text-blue-600'>
						Quản lý Đào tạo
					</h1>
				</div>
				<div className='flex-1 p-4 overflow-y-auto'>
					<ul className='space-y-2'>
						{reorderedMenuItems.map((item, index) => {
							// Chèn Quản lý đào tạo sau Hạng đào tạo (index 3)
							if (index === 3) {
								return (
									<Fragment key='training-management-group'>
										<li key={item.name}>
											<Link
												to={item.href}
												className={`flex items-center p-3 rounded-lg transition-colors ${
													item.current
														? 'bg-blue-50 text-blue-600 font-medium'
														: 'text-gray-700 hover:bg-gray-100'
												}`}>
												<span className='mr-3'>
													{item.icon}
												</span>
												<span>{item.name}</span>
											</Link>
										</li>
										<li>
											<button
												onClick={() =>
													setTrainingManagementOpen(
														!trainingManagementOpen
													)
												}
												className={`flex items-center justify-between w-full p-3 rounded-lg transition-colors ${
													trainingManagementItems.some(
														(item) =>
															pathname.pathname.startsWith(
																item.href
															)
													)
														? 'bg-blue-50 text-blue-600 font-medium'
														: 'text-gray-700 hover:bg-gray-100'
												}`}>
												<div className='flex items-center'>
													<Notebook className='w-5 h-5 mr-3' />
													<span>Quản lý đào tạo</span>
												</div>
												{trainingManagementOpen ? (
													<ChevronUp className='w-5 h-5' />
												) : (
													<ChevronDown className='w-5 h-5' />
												)}
											</button>

											{trainingManagementOpen && (
												<ul className='ml-3 space-y-2'>
													{trainingManagementItems.map(
														(item) => (
															<li
																key={item.name}
																className={
																	'mt-2'
																}>
																<Link
																	to={
																		item.href
																	}
																	className={`flex items-center p-3 rounded-lg transition-colors ${
																		item.current
																			? 'bg-blue-50 text-blue-600 font-medium'
																			: 'text-gray-700 hover:bg-gray-100'
																	}`}>
																	<span className='mr-3'>
																		{
																			item.icon
																		}
																	</span>
																	<span>
																		{
																			item.name
																		}
																	</span>
																</Link>
															</li>
														)
													)}
												</ul>
											)}
										</li>
									</Fragment>
								);
							}
							return (
								<li key={item.name}>
									<Link
										to={item.href}
										className={`flex items-center p-3 rounded-lg transition-colors ${
											item.current
												? 'bg-blue-50 text-blue-600 font-medium'
												: 'text-gray-700 hover:bg-gray-100'
										}`}>
										<span className='mr-3'>
											{item.icon}
										</span>
										<span>{item.name}</span>
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
				<div className='p-4 border-t border-gray-200'>
					{user.Name ? (
						<div className='flex items-center justify-between'>
							<div className='flex items-center'>
								<div className='bg-blue-100 p-2 rounded-full mr-3'>
									<User className='w-5 h-5 text-blue-600' />
								</div>
								<span className='font-medium'>Hi, {user.Name}</span>
							</div>
							<button
								onClick={() => handleLogout()}
								className='text-gray-500 hover:text-red-500 transition-colors'
								title='Đăng xuất'>
								<LogOut className='w-5 h-5' />
							</button>
						</div>
					) : (
						<Link
							to='/auth'
							className='flex items-center justify-center text-white p-3 rounded-lg bg-blue-600 hover:bg-blue-500 transition-colors'>
							<LogIn className='w-5 h-5 mr-3' />
							<span>Đăng nhập</span>
						</Link>
					)}
				</div>
			</nav>

			{/* Mobile sidebar */}
			<div
				className={`lg:hidden fixed inset-0 z-40 transition-all duration-300 ease-in-out ${
					mobileMenuOpen
						? 'opacity-100 visible'
						: 'opacity-0 invisible'
				}`}>
				<div
					className='absolute inset-0 bg-black/50 bg-opacity-50 transition-opacity'
					onClick={() => setMobileMenuOpen(false)}
				/>
				<div
					className={`relative bg-white w-80 h-full shadow-lg transform transition-transform ${
						mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
					}`}>
					<div className='p-4 border-b border-gray-200 flex justify-between items-center'>
						<h1 className='text-xl font-bold text-blue-600'>
							Quản lý Đào tạo
						</h1>
						<button
							onClick={() => setMobileMenuOpen(false)}
							className='p-1 rounded-md hover:bg-gray-100'>
							<X className='w-6 h-6' />
						</button>
					</div>
					<div className='p-4 h-[calc(100%-120px)] overflow-y-auto'>
						<ul className='space-y-2'>
							{reorderedMenuItems.map((item, index) => {
								// Chèn Quản lý đào tạo sau Hạng đào tạo (index 3)
								if (index === 3) {
									return (
										<Fragment key='training-management-group'>
											<li key={item.name}>
												<Link
													to={item.href}
													onClick={() =>
														setMobileMenuOpen(false)
													}
													className={`flex items-center p-3 rounded-lg transition-colors ${
														item.current
															? 'bg-blue-50 text-blue-600 font-medium'
															: 'text-gray-700 hover:bg-gray-100'
													}`}>
													<span className='mr-3'>
														{item.icon}
													</span>
													<span>{item.name}</span>
												</Link>
											</li>
											<li>
												<button
													onClick={() =>
														setTrainingManagementOpen(
															!trainingManagementOpen
														)
													}
													className={`flex items-center justify-between w-full p-3 rounded-lg transition-colors ${
														trainingManagementItems.some(
															(item) =>
																item.current
														)
															? 'bg-blue-50 text-blue-600 font-medium'
															: 'text-gray-700 hover:bg-gray-100'
													}`}>
													<div className='flex items-center'>
														<Notebook className='w-5 h-5 mr-3' />
														<span>
															Quản lý đào tạo
														</span>
													</div>
													{trainingManagementOpen ? (
														<ChevronUp className='w-5 h-5' />
													) : (
														<ChevronDown className='w-5 h-5' />
													)}
												</button>

												{trainingManagementOpen && (
													<ul className='mt-2 ml-8 space-y-2'>
														{trainingManagementItems.map(
															(item) => (
																<li
																	key={
																		item.name
																	}>
																	<Link
																		to={
																			item.href
																		}
																		onClick={() =>
																			setMobileMenuOpen(
																				false
																			)
																		}
																		className={`flex items-center p-3 rounded-lg transition-colors ${
																			item.current
																				? 'bg-blue-50 text-blue-600 font-medium'
																				: 'text-gray-700 hover:bg-gray-100'
																		}`}>
																		<span className='mr-3'>
																			{
																				item.icon
																			}
																		</span>
																		<span>
																			{
																				item.name
																			}
																		</span>
																	</Link>
																</li>
															)
														)}
													</ul>
												)}
											</li>
										</Fragment>
									);
								}
								return (
									<li key={item.name}>
										<Link
											to={item.href}
											onClick={() =>
												setMobileMenuOpen(false)
											}
											className={`flex items-center p-3 rounded-lg transition-colors ${
												item.current
													? 'bg-blue-50 text-blue-600 font-medium'
													: 'text-gray-700 hover:bg-gray-100'
											}`}>
											<span className='mr-3'>
												{item.icon}
											</span>
											<span>{item.name}</span>
										</Link>
									</li>
								);
							})}
						</ul>
					</div>
					<div className='absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200'>
						{user != {} ? (
							<div className='flex items-center justify-between'>
								<div className='flex items-center'>
									<div className='bg-blue-100 p-2 rounded-full mr-3'>
										<User className='w-5 h-5 text-blue-600' />
									</div>
									<span className='font-medium'>
										{
											user.Name
										}
									</span>
								</div>
								<button
									onClick={() => handleLogout()}
									className='text-gray-500 hover:text-red-500 transition-colors'
									title='Đăng xuất'>
									<LogOut className='w-5 h-5' />
								</button>
							</div>
						) : (
							<Link
								to='/auth/signin'
								onClick={() => setMobileMenuOpen(false)}
								className='flex items-center p-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors'>
								<LogIn className='w-5 h-5 mr-3' />
								<span>Đăng nhập</span>
							</Link>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
